// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"cPg00","smallLinkTypography":"_2W2GQ","titleTypography":"_1MnyJ","cardTitleTypography":"_3Q54s","truncate":"ym6ys","baseCard":"_1zX44","line":"_2IuNk","section":"_2jtgU","sectionTitle":"_1gjKU","left":"_3ktCU","right":"pR4BY","list":"_304y7","address":"_3UJvV","label":"_3jfbd","detail":"_3MVIQ","companyCard":"_35li6","editPersonalInfo":"_2TYYj"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PersonalInfo/PersonalInfo.scss
// module id = 2576
// module chunks = 0